//Original
// import axios from 'axios';

// export default axios.create({
//   baseURL: "https://localhost:44378/api"
// });

// -------------Mine----------------
import { checkNull } from "utils/utils";
import axios from "axios";

const makeAxios = (url) => {
  const getUserToken = isFull => {
    let userToken = localStorage.getItem("user-token");
    return checkNull(userToken) ? '' : (isFull ? `Bearer ${userToken}` : userToken);
  }

  const removeToken = _ => {
    localStorage.removeItem("user-token");
    localStorage.removeItem("user-refresh-token");
    localStorage.removeItem("user_general_key");
  }

  const getUserRefreshToken = _ => {
    return localStorage.getItem("user-refresh-token");
  }

  let axiosInstance = axios.create({
    baseURL: url,
    maxContentLength: 1073741824,
    headers: {
      "Content-Type": "application/json"
    },
    // withCredentials: true
  });

  const refreshToken = async () => {
    let params = { 
      "RefreshToken": getUserRefreshToken()
    };
    
    // return await axiosInstance.post(process.env.REACT_APP_AUTHENTICATION_TOKEN_WITH_REFRESH_TOKEN , params);
    // return await axiosInstance.post("https://localhost:44378/api/Authenticate/NewTokenWithRefreshToken" , params);
    return await axiosInstance.post("http://10.3.2.53:3000/Authentication/api/Authenticate/NewTokenWithRefreshToken" , params);
  };

  axiosInstance.interceptors.request.use(
    async (config) => {
      let userToken = getUserToken(true);
      if (userToken) {
        // config.headers["x-access-token"] = userToken;
        if (!config.headers.common.Authorization) {
          config.headers.common.Authorization  = userToken;
        }
        
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  axiosInstance.interceptors.response.use(
    (response) => { 
      // debugger;
      return response;
    },
    async (err) => {
      // debugger;
      const originalConfig = err.config;
      if (err.response) {
        //Access Token is expired
        if (err.response.status === 401 && !originalConfig._retry) {
          originalConfig._retry = true;
          try {
            let rs = await refreshToken();
            // debugger;
            if (rs.data.isSuccess === true) {
              // const accessToken = rs.data.data.token;
              window.localStorage.setItem("user-token", rs.data.data.token);
              window.localStorage.setItem("user-refresh-token", rs.data.data.refreshToken);
              // axiosInstance.defaults.headers.common["x-access-token"] = accessToken;

              axiosInstance.defaults.headers.Authorization = getUserToken(true);
              originalConfig.headers.Authorization = getUserToken(true);
              
              return axiosInstance(originalConfig);  
            } else {
                removeToken();
                window.location.reload();
            }

          } catch (_error) {
            if (_error.response && _error.response.data) {
              return Promise.reject(_error.response.data);
            } 
            // removeToken();
            // window.location.reload();
          }
        }

        if (err.response.status === 403 && err.response.data) {
          return Promise.reject(err.response.data);
        }
        // removeToken();
        // window.location.reload();

      }
      return Promise.reject(err);
    }
  );


  // let requestAxiosInstance = axios.create({
  //   baseURL: url,
  //   timeout: 300000,
  //   maxContentLength: 1073741824,
  //   headers: {
  //     'Content-Type': 'application/json',
  //     // 'Authorization': 'Bearer ' + userToken
  //   }
  // })


  // return requestAxiosInstance;
  return axiosInstance;
};

export default makeAxios;
